import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
    WorkplaceInterface,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {isMobile} from 'react-device-detect';
import {useSelector} from 'react-redux';
import {RootState} from '../../reducer';
import {FormControl, InputLabel, MenuItem, MenuList, Pagination, Select} from '@mui/material';
import TextField from '@mui/material/TextField';
import {useNavigate} from 'react-router-dom';
import {MenuInterface} from "../../interface/menu.interface";
import {Book} from "../../interface/book.interface";
import BookRentalListTable from "./table/BookRentalListTable";

interface State {
    searchType: string,
    searchKeyword: string,
    totalCount: number,
    bookList: Book[],
    page: number,
    menu: MenuInterface,
    sort: string,
    sortValue: {
        name: number,
        author: number,
        publisher: number,
        lender: number,
    }
}

const initState: State = {
    searchType: constance.searchType.name,
    searchKeyword: '',
    totalCount: 0,
    bookList: [],
    page: 1,
    menu: {
        id: "",
        index: 0,
        name: "",
        path: "",
        subMenu: [],
        viewComment: false,
        placeholder: "",
        allowAdminReply: false,
        allowAdminPost: false,
    },
    sort: 'name',
    sortValue: {
        name: 1,
        author: 1,
        publisher: 1,
        lender: 1,
    }
};

export default function BookRentalList() {
    console.log('[BookRentalList]');
    const [state, setState] = useState<State>(initState);
    const commonData = useSelector((state: RootState) => state.commonData);
    const navigate = useNavigate();
    let {id, workplace, no, page, keyword, searchType} = common.getQuery();

    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);

    useEffect(() => {
        getList();
    }, [commonData.urlPath, page, id, workplace, keyword, searchType, state.sort, state.sortValue]);


    /* 게시글 리스트 */
    function getList() {
        let sortValue: any = state.sortValue;
        let sv = sortValue[state.sort];
        axios.get(constance.api.getBookList, {
            params: {
                workplace: workplace,
                page: page,
                searchKeyword: keyword,
                searchType: searchType,
                sort: state.sort,
                sortValue: sv,
                isAdmin: 'N',
            },
        }).then(value => {
            console.log(value);
            setState({
                ...state,
                bookList: value.data.bookList,
                totalCount: value.data.totalCount,
                page: Number(page)
            })
            let menu = common.getMenuObject(id);
        }).catch(reason => {
            console.log(reason);
        });
    }

    /* 사업장 변경 */
    function handleChangeWorkplace(workplace: WorkplaceInterface) {

        // 일반
        navigate(`${config.url.book}?workplace=${workplace.value}&page=${page}&keyword=&search-type=${searchType}`);
    }

    /* 검색유형 변경 */
    const handleChangeSearchType = (e: any) => {
        navigate(`${config.url.book}?workplace=${workplace}&page=${page}&keyword=${keyword}&search-type=${e.target.value}`);
        // setState({
        //     ...state,
        //     searchType: event.target.value,
        // });
    };

    /* 검색 키워드 상태변경 */
    function handleChangeSearchKeyword(e: any) {
        navigate(`${config.url.book}?workplace=${workplace}&page=${page}&keyword=${e.target.value}&search-type=${searchType}`);
        // setState({
        //     ...state,
        //     searchKeyword: e.target.value,
        // });
    }

    /* 검색 실행 */
    function handleSearch(e: any | null) {
        console.log(e)
        if (e.keyCode == 13 || e.type == 'click') {
            getList();
        }
    }


    /* 글쓰기 페이지 이동 */
    function handlePostWrite() {
        navigate(`${config.url.postWrite}?id=${id}`);
    }

    /* 페이지 변경 */
    function changePagination(event: any, page: number) {
        if (page == 0) {
            page = event.target.value;
        }
        setState({
            ...state,
            page: page
        })
        navigate(`${config.url.book}?workplace=${workplace}&page=${page}&search-type=${searchType}&keyword=${keyword}`);
    }

    function getTable() {

        /* 도서대여 게시판*/
        return <BookRentalListTable bookList={state.bookList} menu={state.menu} getList={getList} state={state} setState={setState}/>
    }


    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center', p: 1}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', mb: 2,
                }}>
                    {/* 사업장 선택이 있는 게시판일 경우 => 사업장 선택 버튼 생성 */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center', alignItems: 'center',
                        width: {xs: 1, sm: 1, md: 600}
                    }}>
                        {
                            Object.keys(constance.workplace).map((key, index) => {
                                const workplaceObject: any = constance.workplace;
                                const _workplace: WorkplaceInterface = workplaceObject[key];
                                return (
                                    <Stack key={index} sx={{position: 'relative', width: {xs: 0.2, sm: 0.2, md: 80}}}>
                                        <Button variant={workplace === _workplace.value ? 'contained' : 'outlined'}
                                                color={'error'}
                                                onClick={() => handleChangeWorkplace(_workplace)}
                                                sx={{
                                                    mr: 1,
                                                    background: workplace === _workplace.value ? '#d32f2f' : 'var(--scc-surface)'
                                                }}>
                                            <Typography variant={"subtitle1"}>
                                                {_workplace.name}
                                            </Typography>
                                        </Button>
                                    </Stack>
                                );
                            })
                        }
                    </Box>

                    {/* 검색 카테고리 */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: 600,
                        maxWidth: 1,
                        mt: 2,
                        mb: 2,
                    }}>
                        <Box sx={{width: {xs: 0.2, sm: 0.2, md: 100}, backgroundColor: 'var(--scc-surface)'}}>
                            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}
                                         sx={{'>div': {height: isMobile ? 'inherit' : 52}}}>
                                <Select
                                    labelId="search-category"
                                    value={searchType}
                                    onChange={handleChangeSearchType}
                                >
                                    <MenuItem value={constance.searchType.name}>
                                        <Typography variant={isMobile ? 'caption' : 'subtitle1'}>도서명</Typography>
                                    </MenuItem>
                                    <MenuItem value={constance.searchType.author}>
                                        <Typography variant={isMobile ? 'caption' : 'subtitle1'}>저자</Typography>
                                    </MenuItem>
                                    <MenuItem value={constance.searchType.publisher}>
                                        <Typography variant={isMobile ? 'caption' : 'subtitle1'}>출판사</Typography>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Box sx={{width: 3 / 5, ml: 1}}>
                            <TextField placeholder="검색어 입력"
                                       fullWidth
                                       size={isMobile ? 'small' : 'medium'}
                                       value={keyword}
                                       onChange={(e) => handleChangeSearchKeyword(e)}
                                       onKeyDown={(e) => handleSearch(e)}
                                       label="검색" variant="outlined"
                                       sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                            />
                        </Box>

                        <Box sx={{
                            height: isMobile ? 1 : 52,
                            ml: 1,
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <Button variant={'contained'}
                                    color={'whiteOutlined'}
                                    size={isMobile ? 'small' : 'medium'}
                                    sx={{height: 1}}
                                    onClick={(e) => handleSearch(e)}>
                                <Typography variant={isMobile ? 'caption' : 'subtitle1'}>검색</Typography>
                            </Button>
                        </Box>
                    </Box>

                    {/* 게시판 리스트 */}
                    <Box sx={{
                        width: 1,
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        mt: 1
                    }}>
                        <Box sx={{display: 'flex'}}>
                            <Typography>총</Typography>
                            <Typography sx={{ml: 1, color: 'red', mr: 0.5}}>{state.totalCount}</Typography>
                            <Typography>건</Typography>
                        </Box>
                    </Box>


                    {/* 게시글 목록 */}
                    <Box sx={{mt: 2, width: 1}}>
                        {
                            getTable()
                        }
                    </Box>


                    {/* 페이징 */}
                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2, mb: 1}}>
                        <Stack spacing={1}>
                            <Pagination
                                count={Math.ceil(state.totalCount / 10)}
                                variant="outlined"
                                page={state.page}
                                shape={'rounded'}
                                boundaryCount={isMobile ? 0 : 2}
                                onChange={changePagination}/>
                        </Stack>
                        <FormControl sx={{ml: 2}}>
                            <InputLabel>페이지</InputLabel>
                            <Select
                                value={state.page}
                                label="페이지"
                                size={"small"}
                                onChange={(event) => changePagination(event, 0)}
                            >
                                {
                                    new Array(Math.ceil(state.totalCount / 10)).fill(0).map((value, index) => {
                                        return <MenuItem value={index + 1}>{index + 1}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Box>


                </Stack>
            </Box>
        </>
    );
}
